import useOnlineStatus from "../hooks/useOnlineStatus";
import { OnlineStatusContext } from "./OnlineStatusContext";

export default function OnlineStatusProvider({ children }) {
  const onlineState = useOnlineStatus();
  return (
    <OnlineStatusContext.Provider value={onlineState}>
      {children}
    </OnlineStatusContext.Provider>
  );
}
